<template>
    <div class="match-stats-table-wrap">
        <table class="match-stats-table">
            <thead>
                <tr>
                    <th>Дата</th>
                    <th>Матч</th>
                    <th>Счёт</th>
                    <th v-if="showAttack">Атака</th>
                    <th v-if="showServe">Подача</th>
                    <th v-if="showReception">Приём</th>
                    <th>Очки</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in rows" :key="row.match_id">
                    <td class="col-date">{{ row.date }}</td>
                    <td class="col-match">{{ row.match_label }}</td>
                    <td class="col-score">{{ row.score || '—' }}</td>
                    <td v-if="showAttack" class="col-num">{{ row.attack_efficiency }}%</td>
                    <td v-if="showServe" class="col-num">{{ row.serve_aces }}</td>
                    <td v-if="showReception" class="col-num">{{ row.reception_positive_pct }}%</td>
                    <td class="col-num col-points">{{ row.total_points }}</td>
                </tr>
            </tbody>
        </table>
        <p v-if="!rows.length" class="match-stats-table__empty">Нет матчей за выбранный период</p>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    rows: { type: Array, default: () => [] },
    position: { type: String, default: null },
});

const showAttack = computed(() => props.position !== 'libero');
const showServe = computed(() => props.position !== 'libero');
const showReception = computed(() =>
    ['libero', 'outside'].includes(props.position)
);
</script>
